import { createApp } from "vue";
import { createPinia } from "pinia";
import router from "./router";
import axios from "axios";
import { createBootstrap } from "bootstrap-vue-next";
import SetInterval from "@/plugins/SetInterval";
import App from "./App.vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import "mapbox-gl/dist/mapbox-gl.css";

const app = createApp(App);
const pinia = createPinia();

app.config.globalProperties.$axios = axios;

app.use(pinia);
app.use(router);
app.use(createBootstrap());
app.use(SetInterval);

if (import.meta.env.PROD) {
  app.config.devtools = false;
}

app.mount("#app");
